import moment from 'moment';

import config from 'src/config';

utilsService.$inject = [
  '$rootScope',
  '$state',
  '$document',
  '$timeout',
  '$q',
  'tl.auth.service',
  'tl.user.service',
  'loggerService',
  'jsSdk.user'
];

function todaysDate() {
  const utcDate = moment.utc();

  if (utcDate.hours() < 6) {
    utcDate.date(utcDate.date() - 1);
  }

  utcDate.hours(6);
  utcDate.minutes(0);
  utcDate.seconds(0);
  utcDate.milliseconds(0);

  return utcDate;
}

function s4() {
  return Math.floor((1 + Math.random()) * 0x10000)
    .toString(16)
    .substring(1);
}

export default function utilsService($rootScope, $state, $document, $timeout, $q, authService, userService, loggerService, jsSdkUserService) {
  class UtilsService {
    sanitizeNewlines(content) { //eslint-disable-line
      if (content) return content.replace(/\n\r?/g, '<br />');

      return '';
    }

    get isMobile() { //eslint-disable-line
      return {
        Android: function() {
          return navigator.userAgent.match(/Android/i);
        },
        iOS: function() {
          return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        }
      };
    }

    isMobileDevice() {
      return this.isMobile.Android() || this.isMobile.iOS();
    }

    isNewUser(user) { //eslint-disable-line
      const diff = (Date.now() - user.created) / 1000;

      return diff <= 10;
    }

    guid() { //eslint-disable-line
      return `${s4()}${s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;
    }

    scrollTo(_id, _offset, _speed, _delay) { //eslint-disable-line
      const id = _id || null;
      const offset = _offset || 30;
      const delay = _delay || 0;

      const el = document.getElementById(id);

      $timeout(function() {
        try {
          $document.scrollToElement(el, offset, 500);
        } catch (err) {
          console.log(err);
        }
      }, delay);
    }

    slugify(name) { //eslint-disable-line
      return name.toLowerCase().replace(/[^\w ]+/g, '').replace(/ +/g, '-');
    }

    link(url, params) {
      if (params) {
        url += this.convertParamsToQueryString(params);
      }

      window.location = url;
    }

    mailto(target, subject, body) {
      if (!subject) {
        subject = '';
      }

      if (!body) {
        body = '';
      }

      const mailtoLink = `mailto:${target}?Subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

      this.link(mailtoLink);
    }

    sms(number) {
      this.link(`sms:${number}`);
    }

    futureDate(time) { //eslint-disable-line
      const today = todaysDate();

      return today.date(today.date() + time);
    }

    getDayName(dayNumber) { //eslint-disable-line
      dayNumber = parseInt(dayNumber, 10);

      switch (dayNumber) {
        case 0:
          return 'Sunday';
        case 1:
          return 'Monday';
        case 2:
          return 'Tuesday';
        case 3:
          return 'Wednesday';
        case 4:
          return 'Thursday';
        case 5:
          return 'Friday';
        case 6:
          return 'Saturday';
        default:
          return '';
      }
    }

    getDayNameShort(dayNumber) { //eslint-disable-line
      let day;

      switch (dayNumber) {
        case 0:
          day = 'Sun';
          break;
        case 1:
          day = 'Mon';
          break;
        case 2:
          day = 'Tues';
          break;
        case 3:
          day = 'Wed';
          break;
        case 4:
          day = 'Thurs';
          break;
        case 5:
          day = 'Fri';
          break;
        case 6:
          day = 'Sat';
          break;
        default:
          break;
      }

      return day;
    }

    logout() { //eslint-disable-line
      authService.logout();

      $rootScope.currentUser = null;

      $state.go('app.home');
    }

    getMapUrl(address, link) { //eslint-disable-line
      if (!address || !address.city || !address.state || !address.zip) return;

      const query = [
        address.address,
        address.city,
        address.state,
        address.zip
      ].join(' ');

      if (link) {
        return 'https://www.google.com/maps?q=' + encodeURIComponent(query) + '&key=AIzaSyABdXTugKjdXcNgwYO9wdX6GfVJNHD2_84'; //eslint-disable-line
      }

      return config.GOOGLE_MAPS_API_URL + '?q=' + encodeURIComponent(query) + '&key=' + config.GOOGLE_MAPS_API_KEY; //eslint-disable-line
    }

    createUrl(path) { //eslint-disable-line
      const baseUrl = window.location.protocol + '//' + window.location.host; //eslint-disable-line

      return baseUrl + path;
    }

    mailtoLink(url, content) { //eslint-disable-line
      const message = 'Here';

      return 'mailto:?subject=' + content + '&body=' + encodeURIComponent(message) + ''; //eslint-disable-line
    }

    twitterLink(url, content) { //eslint-disable-line
      return 'https://twitter.com/share?url=' + encodeURIComponent(url) + '&text=' + encodeURIComponent(content); //eslint-disable-line
    }

    facebookLink(url) { //eslint-disable-line
      const appId = '301282840002421';
      const redirect = 'https://www.tablelist.com/download';

      return 'https://www.facebook.com/dialog/share?app_id=' + encodeURIComponent(appId) + '&display=page' + '&href=' + encodeURIComponent(url) + '&redirect_uri=' + redirect; //eslint-disable-line
    }

    convertParamsToQueryString(params) { //eslint-disable-line
      if (!params) return null;

      const data = [];

      for (let key in params) { //eslint-disable-line
        const val = params[key];
        const param = `${encodeURIComponent(key)}=${encodeURIComponent(val)}`;
        data.push(param);
      }

      return '?' + data.join('&'); //eslint-disable-line
    }

    errorMessage(resp) { //eslint-disable-line
      let error = 'An error has occurred. Please try again or contact hello@tablelist.com for support.';

      if (resp && resp.message) {
        error = resp.message;
      } else if (resp && resp.errors && resp.errors[0] && resp.errors[0].message) {
        error = resp.errors[0].message;
      } else if (resp && resp.data && resp.data.errors && resp.data.errors[0] && resp.data.errors[0].message) {
        error = resp.data.errors[0].message;
      }

      return error;
    }

    getBookingDateSentence(booking) { //eslint-disable-line
      if (!booking || !booking.date) return '';

      const now = moment.utc();
      const bookingDate = moment.utc(booking.date);

      const isToday = now.isSame(bookingDate, 'day');

      const a = (isToday) ? 'Today' : bookingDate.format('dddd');

      return a + ', ' + bookingDate.format('MMM Do YYYY') + ' at ' + booking.venue.name; //eslint-disable-line
    }

    defaultCityId() { //eslint-disable-line
      const user = $rootScope.currentUser;

      if (user && user.location && user.location.preferred && user.location.preferred.id) {
        const city = user.location.preferred;

        return city.id;
      }

      return config.DEFAULT_CITY_ID;
    }

    defaultCitySlug() { //eslint-disable-line
      const user = $rootScope.currentUser;
      let citySlug;

      if (user && user.location && user.location.preferred && user.location.preferred.slugName) {
        citySlug = user.location.preferred.slugName;
      }

      return citySlug || config.DEFAULT_CITY_SLUG;
    }

    setPreferredCity(cityId) { //eslint-disable-line
      if (!cityId) throw new Error('cityId');

      const user = $rootScope.currentUser;

      if (!user) return $q.reject(new Error('no current user'));

      if (user.location && user.location.preferred && user.location.preferred.id === cityId) {
        return $q.resolve(user);
      }

      return jsSdkUserService.updatePreferredCity(cityId, {
          city: cityId
        })
        .then(() => {
          return jsSdkUserService.me();
        });
    }

    truncateString(string, maxLength) { //eslint-disable-line
      if (!string) return '';
      if (!maxLength) return string;

      if (string.length > maxLength) {
        string = `${string.slice(0, maxLength)} ...`;
      }

      return string;

    }
  }

  return new UtilsService();
}



// WEBPACK FOOTER //
// ./src/services/utilsService.js